import { IEditCustomerState } from './editCustomerContext';
import { EditCustomerActionTypes, TEditCustomerAction } from './editCustomerActions';

export const editCustomerReducer = (state: IEditCustomerState, action: TEditCustomerAction): IEditCustomerState => {
	switch (action.type) {
		case EditCustomerActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case EditCustomerActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditCustomerActionTypes.SET_ALL_DATA:
			return {
				...state,
				filePath: action.payload.filePath,
				customerId: action.payload.customerId,
				name: action.payload.name,
				email: action.payload.email,
				emailBodyTemplate: action.payload.emailBodyTemplate,
				clientType: action.payload.clientType,
				billTemplateFileData: action.payload.billTemplateFileData,
				billTemplateFilePath: action.payload.billTemplateFilePath,
				billAdvertisingImageData: action.payload.billAdvertisingImageData,
				billAdvertisingImage: action.payload.billAdvertisingImage,
				billAdvertisingLink: action.payload.billAdvertisingLink,
				priceType: action.payload.priceType,
				tips0: action.payload.tips0,
				tips1: action.payload.tips1,
				tips2: action.payload.tips2,
				tips3: action.payload.tips3,
				defaultTips: action.payload.defaultTips,
				isShowLoyaltyProgramButtons: action.payload.isShowLoyaltyProgramButtons,
				baseMcc: action.payload.baseMcc,
				mainMccCardBrand: action.payload.mainMccCardBrand,
				mainMccCardMcc: action.payload.mainMccCardMcc,
				mccCards: action.payload.mccCards,
				vivaWalletCredentialsId: action.payload.vivaWalletCredentialsId,
				ads: action.payload.ads,
				menuVersion: action.payload.menuVersion,
				contentVersion: action.payload.contentVersion,
				mixpanelToken: action.payload.mixpanelToken,
				stopListSyncIntervalMinutes: action.payload.stopListSyncIntervalMinutes,
				IDSelectedCustomerDefaultLanguage: action.payload.IDSelectedCustomerDefaultLanguage,
				IDsSelectedCustomerLanguages: action.payload.IDsSelectedCustomerLanguages,
				customerLanguages: action.payload.customerLanguages,
				tags: action.payload.tags,
				isActiveBpa: action.payload.isActiveBpa,
			};
		case EditCustomerActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case EditCustomerActionTypes.SET_FILE:
			return {
				...state,
				fileId: action.payload.fileId,
				sourceUrlLocally: action.payload.sourceUrlLocally,
			};
		case EditCustomerActionTypes.DELETE_PHOTO:
			return {
				...state,
				filePath: null,
				fileId: null,
				sourceUrlLocally: null,
			};
		case EditCustomerActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case EditCustomerActionTypes.CHANGE_EMAIL:
			return {
				...state,
				email: action.payload.email,
			};
		case EditCustomerActionTypes.CHANGE_EMAIL_BODY_TEMPLATE:
			return {
				...state,
				emailBodyTemplate: action.payload.emailBodyTemplate,
			};
		case EditCustomerActionTypes.SET_CLIENT_TYPE:
			return {
				...state,
				clientType: action.payload.clientType,
			};
		case EditCustomerActionTypes.CHANGE_BILL_TEMPLATE_FILE_DATA:
			return {
				...state,
				billTemplateFileData: action.payload.billTemplateFileData,
			};
		case EditCustomerActionTypes.CHANGE_BILL_ADVERTISING_IMAGE_DATA:
			return {
				...state,
				billAdvertisingImageData: action.payload.billAdvertisingImageData,
			};
		case EditCustomerActionTypes.CHANGE_BILL_ADVERTISING_LINK:
			return {
				...state,
				billAdvertisingLink: action.payload.billAdvertisingLink,
			};
		case EditCustomerActionTypes.DELETE_BILL_ADVERTISING_IMAGE:
			return {
				...state,
				billAdvertisingImageData: { fileId: '', fileHash: null, fileName: null },
				billAdvertisingImage: null,
			};
		case EditCustomerActionTypes.CHANGE_PRICE_TYPE:
			return {
				...state,
				priceType: action.payload.priceType,
			};
		case EditCustomerActionTypes.SET_TIPS_0:
			return {
				...state,
				tips0: action.payload.tips0,
			};
		case EditCustomerActionTypes.SET_TIPS_1:
			return {
				...state,
				tips1: action.payload.tips1,
			};
		case EditCustomerActionTypes.SET_TIPS_2:
			return {
				...state,
				tips2: action.payload.tips2,
			};
		case EditCustomerActionTypes.SET_TIPS_3:
			return {
				...state,
				tips3: action.payload.tips3,
			};
		case EditCustomerActionTypes.SET_DEFAULT_TIPS:
			return {
				...state,
				defaultTips: action.payload.defaultTips,
			};
		case EditCustomerActionTypes.TOGGLE_SHOW_LOYALTY_PROGRAM_BUTTONS:
			return {
				...state,
				isShowLoyaltyProgramButtons: !state.isShowLoyaltyProgramButtons,
			};
		case EditCustomerActionTypes.CHANGE_BASE_MCC:
			return {
				...state,
				baseMcc: action.payload.baseMcc,
			};
		case EditCustomerActionTypes.CHANGE_MCC_CARD:
			return {
				...state,
				mccCards: action.payload.mccCards,
			};
		case EditCustomerActionTypes.CHANGE_MAIN_MCC_CARD_BRAND:
			return {
				...state,
				mainMccCardBrand: action.payload.mainMccCardBrand,
			};
		case EditCustomerActionTypes.CHANGE_MAIN_MCC_CARD_MCC:
			return {
				...state,
				mainMccCardMcc: action.payload.mainMccCardMcc,
			};
		case EditCustomerActionTypes.SET_VIVA_WALLET_CREDENTIALS_ID:
			return {
				...state,
				vivaWalletCredentialsId: action.payload.vivaWalletCredentialsId,
			};
		case EditCustomerActionTypes.SET_ADS:
			return {
				...state,
				ads: action.payload.ads,
			};
		case EditCustomerActionTypes.CHANGE_MENU_VERSION:
			return {
				...state,
				menuVersion: action.payload.menuVersion,
			};
		case EditCustomerActionTypes.CHANGE_CONTENT_VERSION:
			return {
				...state,
				contentVersion: action.payload.contentVersion,
			};
		case EditCustomerActionTypes.SET_MIXPANEL_TOKEN:
			return {
				...state,
				mixpanelToken: action.payload.mixpanelToken,
			};
		case EditCustomerActionTypes.SET_STOP_LIST_SYNC_INTERVAL_MINUTES:
			return {
				...state,
				stopListSyncIntervalMinutes: action.payload.stopListSyncIntervalMinutes,
			};
		case EditCustomerActionTypes.SET_FETCHED_LANGUAGES:
			return {
				...state,
				fetchedLanguages: action.payload.fetchedLanguages,
			};
		case EditCustomerActionTypes.SET_ID_CUSTOMER_DEFAULT_LANGUAGE:
			return {
				...state,
				IDSelectedCustomerDefaultLanguage: action.payload.IDSelectedCustomerDefaultLanguage,
			};
		case EditCustomerActionTypes.SET_IDs_CUSTOMER_LANGUAGES:
			return {
				...state,
				IDsSelectedCustomerLanguages: action.payload.IDsSelectedCustomerLanguages,
				tags: action.payload.tags,
			};
		case EditCustomerActionTypes.CHANGE_TAGS:
			return {
				...state,
				tags: action.payload.tags,
			};
		case EditCustomerActionTypes.TOGGLE_ACTIVATE_BPA:
			return {
				...state,
				isActiveBpa: !state.isActiveBpa,
			};
		case EditCustomerActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditCustomerActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditCustomerActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				sourceUrlLocally: null,
				name: '',
				email: '',
				emailBodyTemplate: '',
				clientType: null,
				billTemplateFileData: {
					fileId: '',
					fileHash: null,
					fileName: null,
				},
				priceType: null,
				billTemplateFilePath: null,
				billAdvertisingImageData: {
					fileId: '',
					fileHash: null,
					fileName: null,
				},
				billAdvertisingImage: null,
				billAdvertisingLink: null,
				tips0: null,
				tips1: null,
				tips2: null,
				tips3: null,
				defaultTips: null,
				isShowLoyaltyProgramButtons: false,
				baseMcc: null,
				mainMccCardBrand: null,
				mainMccCardMcc: null,
				mccCards: [],
				vivaWalletCredentialsId: null,
				ads: '',
				menuVersion: '',
				contentVersion: '',
				mixpanelToken: '',
				stopListSyncIntervalMinutes: 5,
				IDSelectedCustomerDefaultLanguage: null,
				IDsSelectedCustomerLanguages: [],
				customerLanguages: [],
				tags: [],
				isActiveBpa: false,
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
